module.exports = __webpack_public_path__ + "img/2.ad1c5dbb.png";